module.exports = __webpack_public_path__ + "static/media/3522.6ed13074.jpg";